<template>
  <router-view/>
</template>
<script setup>

</script>
<style lang="scss">
*{
  margin: 0;
  padding: 0;
}
.container{
  max-width: 1400px;
  margin: 0 auto;
}
p{
  margin: 0;
}
body{
  background-color: #f5f7fc;
}
</style>
